<template>
  <li
    class="d-flex align-items-center p-2"
    :class="{ active }"
    style="cursor: pointer;"
    @click="select"
  >
    <img
      :src="require(isOutgoing ? '@/static/user__1_.png' : '@/static/user__2_.png')"
      width="32"
      height="32"
      class="rounded-circle"
    >
    <div
      class="flex-fill ml-2 mr-2"
      v-html="payload"
    />
    <span class="font-size-11 text-nowrap">{{ createdAt }}</span>
  </li>
</template>

<script>
import {mapState} from "vuex";
import dateTimeSameHuman from "../../../../utils/dateTimeSameHuman";
import {EmitterClient, TypeIncoming, TypeOutgoing} from "../../../../services/chat/const";

export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('room', [
      'messageIdSearch',
    ]),
    query() {
      return this.$store.state.roomSearch.query;
    },
    isEmitterClient() {
      return this.source?.emitter === EmitterClient
    },
    type() {
      return this.isEmitterClient ? TypeIncoming : TypeOutgoing;
    },
    isIncoming() {
      return this.type === TypeIncoming;
    },
    isOutgoing() {
      return this.type === TypeOutgoing;
    },
    createdAt() {
      return dateTimeSameHuman.call(this, this.source.created_at)
    },
    active() {
      return this.messageIdSearch === this.source.id
    },
    payload() {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = this.source.payload;

      let payload = tmp.textContent || tmp.innerText;

      const {query: q} = this;
      return payload.replaceAll(new RegExp(q, "ig"), '<strong>$&</strong>')
    },
  },
  methods: {
    select() {
      const {chat_id, id: message_id} = this.source
      this.$store.dispatch('room/goto', {chat_id, message_id})
    },
  },
}
</script>

<style lang="scss" scoped>
li {
  color: #343a40;
}

.active {
  background-color: #EBEFFA !important;
  border-color: #EBEFFA !important;
}
</style>
